import styles from './list.module.css';
import axios from 'axios';
import Loader from '../../components/Loader';
import { authData } from "../../components/getAuth";
import { useForm } from "react-hook-form";
import { useState } from 'react';

const CancelPopup = ({ modalClose, bookingId, camcelItem }) => {
  const auth = authData();
  const API_TOKEN = auth?.api_token;
  const [loading, setLoading] = useState(false);

  const { register, handleSubmit, formState: { errors } } = useForm({
    mode: 'onChange'
  });

  const onSubmitLocal = (data) => {
    modalClose();
    setLoading(true);
    data = { ...data, status: -1 };

    axios.put(process.env.REACT_APP_API_URL + 'v1/bookings/' + bookingId, data, {
      headers: {
        Authorization: `Bearer ${API_TOKEN}`,
      }
    }).then(response => {
      if (response.data.status === 'SUCCESS') {
        camcelItem(response.data.message, bookingId);
      } else {
        setLoading(false);
      }
    }).catch(error => {
      setLoading(false);
    });
  }


  return (<>
    {loading && <Loader />}
    <div className={`${styles.FullDiv}`}>
      <h2 className={`${styles.PopupTitle}`}>Sure? You want to cancel this Booking?</h2>
      <form onSubmit={handleSubmit(onSubmitLocal)}>
        <div className={`${styles.FormGroupFull}`}>
          <label className={`${styles.FormLabel}`}>Resaon*</label>
          <textarea className={`${styles.FormControlTextArea}`} {...register("cancel_note", { required: 'Please enter reason of cancel' })}></textarea>
          {errors.cancel_note && <span className={`${styles.ErrorM}`}>{errors.cancel_note.message}</span>}
        </div>
        <div className={`${styles.FormButtonArea}`}>
          <input className={`${styles.CancelBU}`} value="No" type="button" onClick={modalClose.bind(this)} />
          <input className={`${styles.SubmitBU}`} value="Yes" type="submit" />
        </div>
      </form>
    </div>
  </>)
}

export default CancelPopup;